import { ServiceData } from '@/types';

import articles from './FITNESS_ARTICLES_LV.json';
import exercises from './FITNESS_EXERCISES_LV.json';
import recipes from './FITNESS_RECIPES_LV.json';

export const FITNESS_DATA_LV: ServiceData = {
  articles,
  exercises,
  recipes,
};
